import * as React from 'react'
import { v4 as uuidv4 } from 'uuid'

type Props = React.SVGProps<SVGSVGElement> & {
  collapsed?: boolean
}

export const FullLogo = ({ collapsed, ...svgProps }: Props) => {
  const uid = uuidv4()
  const paint0 = `paint0_linear_${uid}`
  const paint1 = `paint1_linear_${uid}`
  const width = collapsed ? 24 : 151
  const height = 24
  const viewBox = collapsed ? '0 0 32 24' : '0 0 151 24'

  return (
    <svg
      data-test-id="full-logo"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M0.485261 9.41341L4.89705 5.21875L14.659 16.5439L14.6584 16.5445L18.969 21.5453H8.98282L0.378524 11.5632C-0.164872 10.9328 -0.117909 9.9869 0.485261 9.41341Z"
        fill={`url(#${paint0})`}
      />
      <path
        d="M4.89844 5.2201L9.63261 0.718932C9.91262 0.4527 10.247 0.282985 10.5377 0.175781L20.1493 11.3265L27.3415 19.3756C28.1945 20.3446 27.4097 21.5467 26.7224 21.5467H18.9704L14.6598 16.5458L14.6604 16.5452L4.89844 5.2201Z"
        fill="#52BEFF"
      />
      <path
        d="M11.4854 0H26.7199C27.4072 0 28.192 1.20212 27.3389 2.17112L19.662 10.7627L10.5352 0.174422C10.8793 0 11.4854 0 11.4854 0Z"
        fill={`url(#${paint1})`}
      />
      {!collapsed && (
        <>
          {/* E */}
          <path
            d="M31.8164 2.05469H42.5729V4.27426H34.3103V9.51151H42.5729V11.7061H34.3103V17.2925H42.5729V19.5121H31.8164V2.05469Z"
            fill="black"
          />
          {/* A */}
          <path
            d="M53.5855 17.1157H53.4608C52.5381 19.0361 51.4907 19.884 48.9219 19.884C46.3532 19.884 44.6074 18.6121 44.6074 16.2677V15.6443C44.6074 13.6243 46.2284 12.0031 49.2461 12.0031H53.5606V11.0056C53.5606 8.83592 52.588 7.963 50.6178 7.963C48.5478 7.963 47.5503 8.68629 47.4755 10.033L47.4505 10.5318H45.1063C45.2309 7.53909 47.0015 5.91797 50.7674 5.91797C54.1093 5.91797 55.9298 7.38945 55.9298 11.0305V16.4424C55.9298 17.1905 56.1792 17.4399 56.9274 17.4399H57.6507V19.5099C57.1768 19.5847 56.7778 19.6346 56.1044 19.6346C54.5831 19.6346 53.5855 19.0111 53.5855 17.1157ZM49.5205 17.814C52.0393 17.814 53.5606 17.0908 53.5606 14.2726V13.7739H49.271C47.5752 13.7739 46.9517 14.6467 46.9517 15.744V16.1181C46.9517 17.1905 47.7497 17.814 49.5205 17.814Z"
            fill="black"
          />
          {/* S */}
          <path
            d="M58.6699 15.1473H61.0142L61.0391 15.646C61.114 17.2172 62.4607 17.716 64.5556 17.716C66.85 17.716 67.8725 17.2172 67.8725 16.1198V15.8705C67.8725 14.7233 67.3738 14.3991 65.8026 14.1496L62.6603 13.6509C60.3159 13.2768 59.044 12.2044 59.044 10.1345V9.63567C59.044 7.29136 61.2886 6.01953 64.3312 6.01953C68.6955 6.01953 69.7181 8.01465 69.8427 10.6332H67.4984L67.4735 10.1594C67.3987 8.78775 66.6755 8.08947 64.3062 8.08947C62.1116 8.08947 61.3883 8.66311 61.3883 9.7604V10.0098C61.3883 10.8577 61.8372 11.2567 63.2338 11.4811L66.3263 11.9551C68.9948 12.379 70.2168 13.4264 70.2168 15.7208V16.2197C70.2168 18.3893 68.0471 19.761 64.5556 19.761C61.1639 19.761 58.7947 18.6637 58.6699 15.1473Z"
            fill="black"
          />
          {/* Y */}
          <path
            d="M72.4547 23.8741V21.8042H73.7765C74.9985 21.8042 75.3476 21.3304 76.021 19.6095L70.6641 6.24219H73.2834L77.2181 16.4672H77.3427L80.9265 6.24219H83.4218L78.4152 19.5098C76.8689 23.5749 76.0958 23.9989 74.2253 23.9989C73.4522 23.9989 73.0781 23.949 72.4547 23.8741Z"
            fill="black"
          />
          {/* T */}
          {/* <path
            d="M87.4795 16.1204V8.63866H84.5391L85.4422 6.24454H87.4795V3.32659L90.3227 2.70312V6.24454H93.7143V8.63866H90.3227V16.0955C90.3227 16.8188 90.597 17.093 91.3202 17.093H93.7893V19.5122C92.9412 19.587 91.9936 19.6618 91.0209 19.6618C88.5519 19.6618 87.4795 18.6143 87.4795 16.1204Z"
            fill="black"
          /> */}
          <path
            d="M1203.7 378.1h-46.9v-20.4h116.5v20.4h-46.7v115.7h-23z"
            fill="black"
            transform="matrix(0.124 0 0 0.124 -61 -41.6)"
          />
          {/* A */}
          <path
            d="M104.228 17.04H104.078C103.206 18.9353 102.133 19.883 99.5395 19.883C96.9956 19.883 95.25 18.5862 95.25 16.2419V15.5934C95.25 13.4986 96.8959 11.9024 99.9884 11.9024H104.178V10.9298C104.178 8.98459 103.28 8.18649 101.435 8.18649C99.5146 8.18649 98.6168 8.83495 98.542 10.0819L98.5169 10.5308H95.7487C95.8735 7.48821 97.694 5.86719 101.609 5.86719C105.151 5.86719 106.996 7.31366 106.996 11.0046V16.192C106.996 16.9152 107.271 17.1646 107.994 17.1646H108.642V19.5089C108.144 19.5837 107.67 19.6586 106.897 19.6586C105.251 19.6586 104.228 18.9852 104.228 17.04ZM100.363 17.5636C102.832 17.5636 104.178 16.8404 104.178 14.2717V13.8227H100.163C98.6417 13.8227 98.068 14.5958 98.068 15.6184V15.9675C98.068 16.9901 98.7913 17.5636 100.363 17.5636Z"
            fill="black"
          />
          {/* C */}
          <path
            d="M118.968 14.699H121.736C121.637 17.5171 119.866 19.7866 115.901 19.7866C111.511 19.7866 109.541 16.9934 109.541 13.2525V12.5043C109.541 8.76344 111.511 5.94531 115.901 5.94531C119.866 5.94531 121.637 8.2148 121.736 10.9331H118.968L118.943 10.559C118.893 9.48663 118.045 8.46416 115.901 8.46416C113.407 8.46416 112.509 9.68618 112.509 12.1302V13.6266C112.509 16.0706 113.407 17.2926 115.901 17.2926C118.045 17.2926 118.893 16.2203 118.943 15.0481L118.968 14.699Z"
            fill="black"
          />
          {/* H */}
          <path
            d="M135.595 10.6587V19.5121H132.752V11.6313C132.752 9.13742 131.829 8.51396 129.784 8.51396C127.814 8.51396 126.617 9.13742 126.617 11.6313V19.5121H123.773V2.05469H126.617V8.83814H126.766C127.439 7.04248 128.437 5.94519 131.056 5.94519C133.924 5.94519 135.595 7.21702 135.595 10.6587Z"
            fill="black"
          />
          {/* O */}
          <path
            d="M150.394 12.5043V13.2525C150.394 16.9934 148.399 19.7866 144.009 19.7866C139.62 19.7866 137.625 16.9934 137.625 13.2525V12.5043C137.625 8.76344 139.62 5.94531 144.009 5.94531C148.399 5.94531 150.394 8.76344 150.394 12.5043ZM144.009 17.2926C146.453 17.2926 147.426 16.1204 147.426 13.6266V12.1302C147.426 9.63627 146.453 8.46416 144.009 8.46416C141.565 8.46416 140.593 9.63627 140.593 12.1302V13.6266C140.593 16.1204 141.565 17.2926 144.009 17.2926Z"
            fill="black"
          />
        </>
      )}
      <defs>
        <linearGradient
          id={paint0}
          x1="-0.513911"
          y1="7.93545"
          x2="13.9671"
          y2="18.5168"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.042133" stopColor="#ABE6FF" />
          <stop offset="0.648703" stopColor="#57CCFF" />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="10.5352"
          y1="5.38137"
          x2="27.7118"
          y2="5.38137"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#162C80" />
          <stop offset="1" stopColor="#3266FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
